// @ts-nocheck

export type TicketGetWithTicketCommentsContactToAdmin = typeof TicketGetWithTicketCommentsContactToAdmin[keyof typeof TicketGetWithTicketCommentsContactToAdmin];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithTicketCommentsContactToAdmin = {
  true: 'true',
  false: 'false',
} as const;
